import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

function TablePagerSkeleton({ className }: { className?: string }) {
  return (
    <div className={classNames(styles.pager, className)}>
      <Skeleton variant="text" width={160} height={18} />
      <div className={styles.controls}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={32}
            height={32}
            sx={{ borderRadius: "8px" }}
          />
        ))}
      </div>
    </div>
  );
}

export default TablePagerSkeleton;
